export const UploadDocumentsOptions = [
  {
    label: 'Share only with Community ',
    value: '1'
  },
  {
    label: 'Share only with OM Lifeline',
    value: '2'
  }
] as const
